import React from "react";
import TableLoad from "../../TableLoad";
import useWeeklyRefreshFleet from "../../../hooks/useWeeklyRefresh";
import useDashboards from "../../../hooks/useDashboards";
import useFleetEvents from "../../../hooks/useFleetEvents";
import Depvar from "./Depvar";
import CleanData from "./CleanData";
import Deploy from "./Deploy";

interface ITableFleetExecutionTaskProps {
  fleet_execution_id: string;
  expandRows?: boolean;
  handdleViewPopUp: (value: boolean, data: any) => void;
}

export default function TableWeeklyRefreshDepvar({
  fleet_execution_id,
  expandRows,
  handdleViewPopUp,
}: ITableFleetExecutionTaskProps) {
  const { fleetState, loading, errors } = useWeeklyRefreshFleet(fleet_execution_id);

  const stacking = fleetState?.depvars?.map((executionTask: any) => executionTask.machine_input.s3_stacking_paths || executionTask.machine_input.s3_stacking_path || executionTask.machine_input.stacking)
  const depvar_names = fleetState?.depvars?.map((executionTask: any) => executionTask.machine_input.depvar)
  const { eventsState } = useFleetEvents(fleet_execution_id);
  // Extract root paths from task inputs (works for both Airflow and Batch)
  const allTasks = [...(fleetState?.depvars || []), ...(fleetState?.ingest || [])]
  let roots = allTasks
    .map((t: any) => {
      const input = t.machine_input || {}
      return input.s3_root_path || input.s3?.root || input.root
    })
    .filter(Boolean)

  if (roots.length === 0) {
    // Fallback to fleet events for older runs
    roots = eventsState?.events
      ?.filter((e: any) => e.topic === "clean_data")
      ?.map((e: any) => e?.details?.root_path)
      ?.filter(Boolean) || []
  }
  const root_path = roots.length > 0 ? roots[0] : undefined
  const { dashboardsState } = useDashboards(root_path);

  if (loading) return <TableLoad />;
  if (errors) return <p className="p-table-msg">Internal server error</p>;
  if (!fleetState || !fleetState.ingest) {
    return <p className="p-table-msg">No data</p>;
  }

  return (
    <>
      <CleanData
        root_path={root_path}
        stacking_paths={stacking}
        ingestTask={fleetState.ingest}
        dashboardsState={dashboardsState}
        handleViewPopUp={handdleViewPopUp}
        eventsState={eventsState}
      />
      <Deploy
        root_path={root_path}
        depvars={depvar_names}
        deployTask={fleetState.deploy}
        dashboardsState={dashboardsState}
        handleViewPopUp={handdleViewPopUp}
        eventsState={eventsState}
      />
      {fleetState.depvars?.map((executionTask: any) => {
        return (
          <React.Fragment key={executionTask.fleet_execution_task_id}>
            <Depvar
              executionTask={executionTask}
              handleViewPopUp={handdleViewPopUp}
              dashboardsState={dashboardsState}
              eventsState={eventsState}
            />
          </React.Fragment>
        );
      })}
    </>
  );
}
